import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "newBoxItemInfoModalRef",
  id: "kt_modal_new_box_item_info",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-lg modal-dialog-centered",
  style: {"max-width":"1200px"}
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "新增赏品", -1)
const _hoisted_6 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body scroll-y mx-5 mx-xl-15 my-7" }
const _hoisted_9 = { class: "card-header card-header-stretch" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "-", -1)
const _hoisted_14 = { class: "d-flex justify-content-end gap-2" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_vxe_form_item = _resolveComponent("vxe-form-item")!
  const _component_vxe_input = _resolveComponent("vxe-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_vxe_form = _resolveComponent("vxe-form")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_vxe_checkbox = _resolveComponent("vxe-checkbox")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_vxe_form, {
              data: _ctx.formData,
              onSubmit: _ctx.submitEvent,
              class: "row"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_vxe_form_item, {
                    field: "product_brand",
                    "item-render": {}
                  }, {
                    default: _withCtx(({}) => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.product_brand,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.product_brand) = $event)),
                        placeholder: "品牌",
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product_brand_options, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.key,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_vxe_form_item, {
                    field: "is_presale",
                    "item-render": {}
                  }, {
                    default: _withCtx(({}) => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.is_presale,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.is_presale) = $event)),
                        placeholder: "是否预售",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presale_options, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.key,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_vxe_form_item, {
                    field: "name",
                    "item-render": {}
                  }, {
                    default: _withCtx(({}) => [
                      _createVNode(_component_vxe_input, {
                        modelValue: _ctx.formData.name,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.name) = $event)),
                        placeholder: "商品名称",
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_vxe_form_item, {
                    field: "ip",
                    "item-render": {}
                  }, {
                    default: _withCtx(({}) => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.ip,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.ip) = $event)),
                        placeholder: "IP",
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product_ip_options, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.key,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_vxe_form_item, {
                    field: "price_range",
                    "item-render": {}
                  }, {
                    default: _withCtx(({}) => [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_el_input_number, {
                          modelValue: _ctx.formData.min_price,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.min_price) = $event)),
                          min: 0,
                          placeholder: "最低价格",
                          style: {"width":"45%"}
                        }, null, 8, ["modelValue"]),
                        _hoisted_13,
                        _createVNode(_component_el_input_number, {
                          modelValue: _ctx.formData.max_price,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.max_price) = $event)),
                          min: 0,
                          placeholder: "最高价格",
                          style: {"width":"45%"}
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_vxe_form_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_vxe_button, {
                          type: "submit",
                          status: "primary"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_15
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_vxe_button, {
                          type: "button",
                          onClick: _ctx.onReset
                        }, {
                          default: _withCtx(() => [
                            _hoisted_16
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["data", "onSubmit"])
          ]),
          _createVNode(_component_vxe_table, {
            data: _ctx.tableData,
            "row-config": { isHover: true }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_column, {
                field: "id",
                title: "ID"
              }),
              _createVNode(_component_vxe_column, {
                field: "brand",
                title: "品牌"
              }),
              _createVNode(_component_vxe_column, {
                field: "ip",
                title: "IP"
              }),
              _createVNode(_component_vxe_column, {
                field: "name",
                title: "名称"
              }),
              _createVNode(_component_vxe_column, {
                field: "price",
                title: "市场价",
                "sort-type": "number",
                sortable: ""
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_ctx.formatPrice(row.price)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_column, {
                field: "recycle_price",
                title: "回收价",
                "sort-type": "number",
                sortable: ""
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_ctx.formatPrice(row.recycle_price)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_column, {
                field: "is_presale_display",
                title: "预售"
              }),
              _createVNode(_component_vxe_column, {
                field: "arrival_date",
                title: "预计到货日期",
                sortable: ""
              }),
              _createVNode(_component_vxe_column, null, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_vxe_checkbox, {
                    modelValue: row.selected,
                    "onUpdate:modelValue": ($event: any) => ((row.selected) = $event),
                    content: "选取"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _createVNode(_component_vxe_pager, {
            "current-page": _ctx.page.currentPage,
            "onUpdate:current-page": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.page.currentPage) = $event)),
            "page-size": _ctx.page.pageSize,
            "onUpdate:page-size": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.page.pageSize) = $event)),
            total: _ctx.page.totalResult,
            layouts: [
              'PrevJump',
              'PrevPage',
              'Number',
              'NextPage',
              'NextJump',
              'Sizes',
              'FullJump',
              'Total',
            ],
            onPageChange: _ctx.onPageChange
          }, null, 8, ["current-page", "page-size", "total", "onPageChange"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.onSubmit,
            ref: "submitButtonRef"
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ], 512))
}